/**
 * Created by Ning Jiang on 2021-11-22.
 */

import {Emitter, AnimatedParticle} from "pixi-particles";
import {TombstoneRip} from "../TombstoneRip";
import {ParticlesManager} from "../../core/particles/ParticlesManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class SuperMatchParticles extends PIXI.Container {

    private _particlesConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 0.05
        },
        "scale" : {
            "start" : 0.5,
            "end" : 1,
            "minimumScaleMultiplier" : 1.2
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 0,
            "end" : 1000,
            "minimumSpeedMultiplier" : 1.5
        },
        "acceleration" : {
            "x" : 10,
            "y" : 800
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 0,
            "max" : 0
        },
        "noRotation" : true,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 10
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2.5
        },
        "blendMode" : "add",
        "frequency" : 0.08,
        "emitterLifetime" : 1.5,
        "maxParticles" : 1000,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -600,
            "y" : -460,
            "w" : 900,
            "h" : 20
        }
    };
    private _emitter:Emitter | null;

    // private _isPlaying:boolean = false;

    constructor() {
        super();
        this.visible = false;
    }

    public play():void {
        // this._isPlaying = true;
        this.visible = true;

        if(this._emitter) {
            ParticlesManager.removeEmitter(this._emitter);
        }

        this._particlesConfig.spawnRect.x = -NolimitApplication.screenBounds.width * 0.5;
        this._particlesConfig.spawnRect.y = -NolimitApplication.screenBounds.height * 0.5 - 50;
        this._particlesConfig.spawnRect.w = NolimitApplication.screenBounds.width;
        this._emitter = new Emitter(this, [
            {
                framerate : 30,
                loop : true,
                hasLoaded : true,
                textures : TombstoneRip.assetLoader.getTextures("superfs/matchParticles/fireParticle/fire_")
            }
        ], this._particlesConfig);

        this._emitter.particleConstructor = AnimatedParticle;
        ParticlesManager.addEmitter(this._emitter);
    }

    public stop():void {
        if(this._emitter) {
            ParticlesManager.removeEmitter(this._emitter);
        }
        this.visible = false;
    }
}